// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__IkSGU","bigColWidth":"Table_bigColWidth__36R5y","biggerColWidth":"Table_biggerColWidth__a7fII","row":"Table_row__dFwRx","col":"Table_col__35o9I"};